export default __webpack_public_path__ + "static/media/green-underline-icon.d871ce1e.svg";